module.exports = __webpack_public_path__ + "img/time.1867cb21.svg";